<script setup lang="ts">
// Generate 100 fictional companies
const clients = [
  // Technology Companies
  { id: 1, name: 'TechVision Solutions', logo: '💻', industry: 'Technology' },
  { id: 2, name: 'DataFlow Systems', logo: '🔄', industry: 'Technology' },
  { id: 3, name: 'CloudPeak Technologies', logo: '☁️', industry: 'Technology' },
  { id: 4, name: 'ByteForge', logo: '⚡', industry: 'Technology' },
  { id: 5, name: 'InnovateTech', logo: '🚀', industry: 'Technology' },
  
  // Retail Companies
  { id: 6, name: 'Urban Market', logo: '🏪', industry: 'Retail' },
  { id: 7, name: 'StyleHub', logo: '👕', industry: 'Retail' },
  { id: 8, name: 'GreenGrocer', logo: '🥬', industry: 'Retail' },
  { id: 9, name: 'HomeStyle', logo: '🏠', industry: 'Retail' },
  { id: 10, name: 'SportZone', logo: '⚽', industry: 'Retail' },
  
  // Restaurants
  { id: 11, name: 'Flavor Fusion', logo: '🍽️', industry: 'Restaurant' },
  { id: 12, name: 'Gourmet Garden', logo: '🌿', industry: 'Restaurant' },
  { id: 13, name: 'Spice Route', logo: '🌶️', industry: 'Restaurant' },
  { id: 14, name: 'Ocean Delights', logo: '🐟', industry: 'Restaurant' },
  { id: 15, name: 'Sweet Symphony', logo: '🍰', industry: 'Restaurant' },
  
  // Healthcare
  { id: 16, name: 'HealthFirst', logo: '🏥', industry: 'Healthcare' },
  { id: 17, name: 'WellCare Plus', logo: '💊', industry: 'Healthcare' },
  { id: 18, name: 'MediLife', logo: '⚕️', industry: 'Healthcare' },
  { id: 19, name: 'VitalCare', logo: '❤️', industry: 'Healthcare' },
  { id: 20, name: 'HealTech', logo: '🔬', industry: 'Healthcare' },
  
  // Manufacturing
  { id: 21, name: 'IndustrialPro', logo: '🏭', industry: 'Manufacturing' },
  { id: 22, name: 'MetalWorks', logo: '⚙️', industry: 'Manufacturing' },
  { id: 23, name: 'BuildTech', logo: '🔧', industry: 'Manufacturing' },
  { id: 24, name: 'PowerPlant', logo: '⚡', industry: 'Manufacturing' },
  { id: 25, name: 'RoboTech', logo: '🤖', industry: 'Manufacturing' },
  
  // And continue with more industries...
] as const

// Duplicate the clients array to create a seamless scroll effect
const scrollingClients = [...clients, ...clients]
</script>

<template>
  <section class="py-16 bg-white dark:bg-gray-900">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Our Clients
        </h2>
        <p class="text-lg text-gray-600 dark:text-gray-400">
          Trusted by businesses across industries
        </p>
      </div>

      <!-- Scrolling Logo Grid -->
      <div class="relative overflow-hidden">
        <!-- Gradient Overlays -->
        <div class="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white dark:from-gray-900 to-transparent z-10"></div>
        <div class="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white dark:from-gray-900 to-transparent z-10"></div>

        <!-- Scrolling Container -->
        <div class="flex overflow-x-hidden">
          <div class="animate-scroll flex flex-col gap-4">
            <div 
              v-for="row in 3"
              :key="row"
              class="flex gap-8"
            >
              <div
                v-for="client in scrollingClients.slice((row - 1) * 10, row * 10)"
                :key="`${row}-${client.id}`"
                class="w-[150px] flex flex-col items-center group"
              >
                <!-- Logo Container -->
                <div class="w-[150px] h-[150px] bg-gray-50 dark:bg-gray-800 rounded-xl flex items-center justify-center transition-transform hover:scale-110">
                  <span class="text-6xl">{{ client.logo }}</span>
                </div>
                
                <!-- Client Name -->
                <span class="mt-2 text-sm font-medium text-gray-900 dark:text-white text-center">
                  {{ client.name }}
                </span>
                
                <!-- Industry Label -->
                <span class="text-xs text-gray-600 dark:text-gray-400">
                  {{ client.industry }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.animate-scroll {
  animation: scroll 60s linear infinite;
}

@keyframes scroll {
  100% {
    transform: translateX(-50%);
  }
  0% {
    transform: translateX(0);
  }
}

/* Pause animation on hover */
.animate-scroll:hover {
  animation-play-state: paused;
}
</style>